// Guacamole (bureau distant) : actif par defaut (prod / SBG).
// En local, REACT_APP_GUACAMOLE_ENABLED=false (docker-compose.local.yaml) coupe
// la popup SSO et la recuperation du token admin.
export const isGuacamoleEnabled = () =>
  process.env.REACT_APP_GUACAMOLE_ENABLED !== "false";
